import React, { Component } from "react";
import PropTypes from "prop-types";
// Translation
import { injectIntl, FormattedMessage, FormattedHTMLMessage } from "react-intl";

import withStyles from "isomorphic-style-loader/lib/withStyles";
import s from "./CheckboxListItems.css";
import { Button, Collapse, FormGroup } from "react-bootstrap";
import cx from "classnames";

// Redux Form
import {
  Field,
  reduxForm,
  formValueSelector,
  change,
  submit as submitForm,
} from "redux-form";

// Redux
import { connect } from "react-redux";

// Locale
import messages from "../../../../../locale/messages";

// Internal Component
import CustomCheckbox from "../../../../CustomCheckbox";

// Submit
import submit from "../../../SearchForm/submit";

//Images
import DefaultIcon from "/public/SiteIcons/defaultIcon.svg";
import { imageCdnUrl, url } from "../../../../../config";
import downArrow from "/public/SiteIcons/filterAllDownIcon.svg";
import upArrow from "/public/SiteIcons/filterAllUparrow.svg";
import DogIcon from "/public/SiteIcons/dogIcon.svg";
import FencingHeight from "/public/SiteIcons/fencingHeight1.svg";
import tablerFence from "/public/SiteIcons/tablerFence.svg";
import GateIcon from "/public/SiteIcons/gates.svg";
import SecureDogArea from "/public/SiteIcons/secureDogArea.svg";
import { FENCE_CONDITION_OPTIONS, FENCING_HEIGHT_OPTIONS, GATES_TYPE_OPTIONS, NUMBER_OF_DOGS_OPTIONS, SECURE_DOG_AREA_TYPE, SIZE_OF_DOG_OPTIONS } from "../../../../../constants";

class CheckboxListItems extends Component {
  static propTypes = {
    className: PropTypes.any,
    handleTabToggle: PropTypes.any,
    isExpand: PropTypes.bool,
  };

  static defaultProps = {
    isExpand: false,
    options: [],
    showLabel: "Show",
    hideLabel: "Hide",
    isActive: false,
  };

  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
    };
    this.checkboxGroup = this.checkboxGroup.bind(this);
    this.handleToggle = this.handleToggle.bind(this);
    this.renderCollapse = this.renderCollapse.bind(this);
  }

  UNSAFE_componentWillMount() {
    const { isActive } = this.props;
    this.setState({
      isOpen: isActive,
    });
  }

  componentDidMount() {
    const { isActive } = this.props;
    this.setState({
      isOpen: isActive,
    });
  }

  handleToggle() {
    const { isOpen } = this.state;
    this.setState({
      isOpen: !isOpen,
    });
  }

  renderCollapse(input, restArray, isOpen) {
    const { showLabel, hideLabel, showImage } = this.props;

    if (restArray && restArray.length > 0) {
      return (
        <div className={cx(s.space2)}>
          <Collapse className={s.collapseContainer} in={isOpen}>
            <div>
              {restArray.map((option, index) => {
                return (
                  <div key={index} className={cx(s.checkBoxContainer)}>
                    {!option?.isStaticField && <div className={cx(s.space2, s.displayFlex)}>
                      <div>
                        <CustomCheckbox
                          className={"icheckbox_square-green"}
                          name={`${input.name}[${index}]`}
                          value={option.id}
                          checked={input.value.indexOf(option.id) !== -1}
                          onChange={(event) => {
                            const newValue = [...input.value];
                            if (event === true) {
                              newValue.push(option.id);
                            } else {
                              newValue.splice(newValue.indexOf(option.id), 1);
                            }
                            return input.onChange(newValue);
                          }}
                        />
                      </div>
                      {showImage && (
                        <span
                          className={cx(
                            s.checkBoxImage,
                            "svgImg",
                            "checkBoxImageRTL"
                          )}
                        >
                          {option.image ? (
                            <img
                              src={imageCdnUrl + "amenities/" + option.image}
                              className={cx(s.imgSection, "moreSectionRtl")}
                            />
                          ) : (
                            <img
                              src={DefaultIcon}
                              className={cx(s.imgSection, "moreSectionRtl")}
                            />
                          )}
                        </span>
                      )}
                      <span className={cx(s.captionTitle, s.textSection)}>
                        {option.itemName}
                      </span>
                    </div>}

                    {option?.isStaticField && this.renderStaticFields(option)}
                  </div>
                );
              })}
            </div>
          </Collapse>
          <Button
            bsStyle="link"
            type="button"
            className={cx(
              s.btn,
              s.btnLink,
              s.btnLinkSecondary,
              s.toggleLink,
              s.captionTitle,
              s.filterToggleLink,
              s.dropdownOverflow,
              "bgBlack",
              "bgBlackHover"
            )}
            onClick={() => this.handleToggle()}
          >
            {isOpen ? hideLabel : showLabel}
            {isOpen && (
              <img
                src={upArrow}
                className={cx(s.iconLeft,s.iconHeight, "homeTypeIconLeftRTL")}
              />
            )}
            {!isOpen && (
              <img
                src={downArrow}
                className={cx(s.iconLeft, "homeTypeIconLeftRTL")}
              />
            )}
          </Button>
        </div>
      );
    } else {
      return <span />;
    }
  }

  renderStaticFields(option) {
    return (
      <div className={cx(s.formGroupContaier)}>
        {!option.fakeEntry && <FormGroup className={s.formRow}>
          <label className={s.formLabel}>
            <span className={s.iconBg}>
              <img
                src={option.icon}
                className={cx(s.imgSection, "moreSectionRtl")}
              />
            </span>
            {option.label}
          </label>
          <Field
            name={option.itemName}
            component="select"
            className={cx("form-control", s.selectForm)}
          >
            <option value="">{option.placeHolder}</option>
            {option.options.map(({ value, label }) => (
              <option key={value} value={value}>
                {label}
              </option>
            ))}
          </Field>
        </FormGroup>}
      </div>
    )
  }
  checkboxGroup = ({ label, name, options, input, isOpen }) => {
    const { showImage } = this.props;
    const { formatMessage } = this.props.intl;
    let count = 4,
      firstArray = [],
      restArray = [];
    let itemList =
      options && options.length > 0
        ? options.filter((o) => {
          if (o.isEnable == "1" && o.typeId == 11 && o.attachFilter == 1) {
            return o;
          } else if (o.isEnable == "1" && o.typeId != 11) {
            return o;
          }
        })
        : [];

    if (input.name == "safetyAmenities") {
      const staticFields = [
        {
          typeId: 11,
          fakeEntry: false,
          itemName: "fencingHeight",
          label: formatMessage(messages.fencingHeight),
          placeHolder: "Select fencing height",
          isStaticField: true,
          options: FENCING_HEIGHT_OPTIONS.slice(0, -1),
          icon: FencingHeight,
        },
        {
          typeId: 11,
          fakeEntry: false,
          itemName: "gatesType",
          label: formatMessage(messages.gates),
          placeHolder: "Select gate type",
          isStaticField: true,
          options: GATES_TYPE_OPTIONS.slice(0, -1),
          icon: GateIcon,
        },
        {
          typeId: 11,
          fakeEntry: false,
          itemName: "sizeOfDog",
          label: formatMessage(messages.sizeOfDog),
          placeHolder: "Select dog size",
          isStaticField: true,
          options: SIZE_OF_DOG_OPTIONS,
          icon: DogIcon,
        },
        {
          typeId: 11,
          fakeEntry: false,
          itemName: "fenceCondition",
          label: formatMessage(messages.fenceCondition),
          placeHolder: "Select fence condition",
          isStaticField: true,
          options: FENCE_CONDITION_OPTIONS.slice(0, -1),
          icon: tablerFence,
        },
        {
          typeId: 11,
          fakeEntry: false,
          itemName: "numberOfDogs",
          label: formatMessage(messages.numberOfDogs),
          placeHolder: "Select number of dogs",
          isStaticField: true,
          options: NUMBER_OF_DOGS_OPTIONS,
          icon: DogIcon,
        },
        {
          typeId: 11,
          fakeEntry: false,
          itemName: "secureDogAreaType",
          label: formatMessage(messages.secureDogArea),
          placeHolder: "Select dog area",
          isStaticField: true,
          options: SECURE_DOG_AREA_TYPE,
          icon: SecureDogArea,
        }
      ]
      if (itemList.length > 0 && itemList.length % 2 !== 0) {
        itemList.push({
          typeId: 11,
          itemName: "",
          label: "",
          placeHolder: "",
          isStaticField: true,
          fakeEntry: true,
          options: [],
          icon: "",
        })
      }
      staticFields.map((item) => itemList.push(item));
    }

    if (itemList && itemList.length > 0) {
      firstArray = itemList.slice(0, count);
      restArray = itemList.slice(count, itemList.length);
    }

    return (
      <div>
        {firstArray.map((option, index) => {
          return (
            <div key={index} className={cx(s.checkBoxContainer)}>
              {!option?.isStaticField && <div className={cx(s.space2, s.displayFlex)}>
                <div>
                  <CustomCheckbox
                    className={"icheckbox_square-green"}
                    name={`${input.name}[${index}]`}
                    value={option.id}
                    checked={input.value.indexOf(option.id) !== -1}
                    onChange={(event) => {
                      const newValue = [...input.value];
                      if (event === true) {
                        newValue.push(option.id);
                      } else {
                        newValue.splice(newValue.indexOf(option.id), 1);
                      }
                      return input.onChange(newValue);
                    }}
                  />
                </div>
                {showImage && (
                  <span
                    className={cx(
                      s.checkBoxImage,
                      "svgImg",
                      "checkBoxImageRTL"
                    )}
                  >
                    {option.image ? (
                      <img
                        src={imageCdnUrl + "amenities/" + option.image}
                        className={cx(s.imgSection, "moreSectionRtl")}
                      />
                    ) : (
                      <img
                        src={DefaultIcon}
                        className={cx(s.imgSection, "moreSectionRtl")}
                      />
                    )}
                  </span>
                )}
                <span className={cx(s.captionTitle, s.textSection)}>
                  {option.itemName}
                </span>
              </div>}

              {option?.isStaticField && this.renderStaticFields(option)}
            </div>
          );
        })}
        {this.renderCollapse(input, restArray, isOpen)}
      </div>
    );
  };

  render() {
    const { className, handleTabToggle, isExpand } = this.props;
    const { options, captionTitle, fieldName } = this.props;
    const { formatMessage } = this.props.intl;
    const { isOpen } = this.state;

    return (
      <div className={className}>
        <p className={cx(s.moreFilterTitle, s.space4, s.spaceTop4, s.textBold)}>
          {captionTitle}
        </p>
        <div className={cx(s.displayTable, s.space2)}>
          <div className={cx(s.displayTableCell, s.fullWidth)}>
            <Field
              name={fieldName}
              options={options}
              component={this.checkboxGroup}
              isOpen={isOpen}
            />
          </div>
        </div>
      </div>
    );
  }
}

CheckboxListItems = reduxForm({
  form: "SearchForm", // a unique name for this form
  onSubmit: submit,
  destroyOnUnmount: false,
})(CheckboxListItems);

// Decorate with connect to read form values
const selector = formValueSelector("SearchForm"); // <-- same as form name

const mapState = (state) => ({
  fieldsSettingsData: state.listingFields.data,
});

const mapDispatch = {
  change,
  submitForm,
};

export default injectIntl(
  withStyles(s)(connect(mapState, mapDispatch)(CheckboxListItems))
);
